import HttpServiceBase from "@/services/http-service";
import { AsyncPaginatedRequest } from ".";

import { LazyAsyncIter } from "@/iterators";
import MonthPeriod from "@/entities/month-period";
import { SubmissionDTO } from "./documentation-submission-service";
import { Paginated } from "@/pagination";

export interface PayrollPeopleDTO {
  name: string;
  identification_number: string;
  job_start_date: string;
  job_position: string;
  salary: string;
  payroll_id: number;
}
interface PeriodRangeReqParams {
  fromPeriod?: MonthPeriod;
  untilPeriod?: MonthPeriod;
}
export interface GetPayrollPeopleParams extends PeriodRangeReqParams {
  partialIdNumber?: string;
}

interface EntityPayrollsPair {
  payroll_ids: number[];
  entity_id: number;
}

type EntitiesFromPayrollsResponse = EntityPayrollsPair[];

export default class PayrollsService extends HttpServiceBase {
  public getPayrollPeople(
    params: GetPayrollPeopleParams
  ): LazyAsyncIter<Paginated<PayrollPeopleDTO>> {
    const reqParams = {
      search_id_number: params.partialIdNumber,
      until_period: params.untilPeriod?.toYMStr(),
      from_period: params.fromPeriod?.toYMStr(),
    };

    const req = new AsyncPaginatedRequest<PayrollPeopleDTO>(
      "get",
      "payrolls/people",
      reqParams,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();
    return new LazyAsyncIter(req);
  }

  public async getEntityIdsFromPayrollIds(
    payrollIds: number[]
  ): Promise<EntitiesFromPayrollsResponse> {
    const payroll_ids = payrollIds.join(",");
    return (
      await this.httpClient.get<EntitiesFromPayrollsResponse>(
        "payrolls/entities",
        { params: { payroll_ids } }
      )
    ).data;
  }

  public getPayrollsWithDuplicatedIdNumbers(
    params: PeriodRangeReqParams
  ): LazyAsyncIter<Paginated<PayrollPeopleDTO>> {
    const reqParams = {
      from_period: params.fromPeriod?.toYMStr(),
      until_period: params.untilPeriod?.toYMStr(),
    };
    const req = new AsyncPaginatedRequest<PayrollPeopleDTO>(
      "get",
      "payrolls/get-duplicates",
      reqParams,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();
    return new LazyAsyncIter(req);
  }

  public async getSubmissionsFromPayrolls(
    payrollIds: number[]
  ): Promise<GetSubmissionsFromPayrollsData> {
    const payroll_ids = payrollIds.join(",");
    return (
      await this.httpClient.get<GetSubmissionsFromPayrollsData>(
        "payrolls/submissions",
        { params: { payroll_ids } }
      )
    ).data;
  }
}

type GetSubmissionsFromPayrollsData = Record<
  number,
  { payroll_ids: number[]; submission: SubmissionDTO }
>;
